const LEGACY_EMPTY_MARKER = '#######'
const MULTILINE_FIELD_SUFFIX = '#place_name_with_cp_city'

/**
 * Whether a dashboard text column renders its value on several lines. Only the
 * place name with postal code and city fields do: every other text column keeps
 * its single truncated line, so existing values containing "\n" do not make
 * rows taller.
 */
export function isMultilineTextField(field: unknown): boolean {
  return typeof field === 'string' && field.endsWith(MULTILINE_FIELD_SUFFIX)
}

/**
 * Lines to render in a dashboard text cell. The API separates lines with "\n"
 * (e.g. place name then postal code and city).
 */
export function textCellLines(value: unknown): string[] {
  if (
    value === null ||
    value === undefined ||
    value === '' ||
    value === LEGACY_EMPTY_MARKER
  ) {
    return []
  }

  return String(value)
    .split('\n')
    .filter((line) => line.trim() !== '')
}
